<template>
  <button
    @click="copyToClipboard"
    :aria-label="$t('ui.envelopes.create.steps.parties.passwordTab.copyToClipboardControl.label')"
    data-ec="envelope_create_add_recipients_password_tab"
    data-et="copy_to_clipboard_button"
    class="bg-transparent border-none w-fit"
    data-test="copy-button"
    :class="{
      'cursor-pointer text-signableBrandColours-darkGrey hover:text-signableBrandColours-black active:text-signableBrandColours-darkGrey': target ,
      'text-signableBrandColours-midGrey': !target
    }"
  >
    <CopyToClipboardIcon aria-hidden="true" />
  </button>
</template>

<script>
import { defineComponent } from 'vue';
import { useClipboard } from '@vueuse/core';
import { EventBus } from '@/utils/event-bus';

import { CopyToClipboardIcon } from '@/components/library/icons';
import { useI18n } from '@/composables/i18n/i18n';

export default defineComponent({
  components: {
    CopyToClipboardIcon,
  },
  props: {
    target: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { t } = useI18n();
    const { copy } = useClipboard({ source: props.target });
    function copyToClipboard() {
      if (props.target.length) {
        copy(props.target);
        EventBus.$emit('renderGlobalMessage', ({
          message: t('ui.envelopes.create.steps.parties.passwordTab.copyToClipboardControl.successMessage'),
          icon: 'check',
          type: 'success',
        }));
      }
    }
    return {
      copy,
      copyToClipboard,
    };
  },
});

</script>
